import { render, staticRenderFns } from "./ModalPartyInterestInfo.vue?vue&type=template&id=67dd3b76&scoped=true"
import script from "./ModalPartyInterestInfo.vue?vue&type=script&lang=js"
export * from "./ModalPartyInterestInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalPartyInterestInfo.vue?vue&type=style&index=0&id=67dd3b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd3b76",
  null
  
)

export default component.exports